import { Navigate, useParams } from 'react-router'

/**
 * Redirects the retired Bookings > Place cards route into Ordering.
 *
 * The cards describe what a guest ORDERED, so they moved to sit with the rest
 * of ordering. A redirect rather than a 404 because staff print these every
 * service and will have the old path bookmarked.
 *
 * Built from params rather than a relative `../..` so it lands correctly from
 * both the org-level and the venue-level mount.
 */
export function PlacecardsMovedToOrdering() {
  const { org_id: orgId = '', serial = '' } = useParams<{
    org_id: string
    serial: string
  }>()

  return (
    <Navigate
      to={
        serial
          ? `/${orgId}/venues/${serial}/ordering/placecards`
          : `/${orgId}/ordering/placecards`
      }
      replace
    />
  )
}

export default PlacecardsMovedToOrdering
